import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { navigate } from "@reach/router";
import Button from "@material-ui/core/Button";
import Link from "@material-ui/core/Link";
import { SUBSCRIPTION_ACTION_TYPES } from "../../redux-saga/actionTypes/index";
import styles from "./styles";

class ProfileSelection extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  handleClick(profile) {
    const { setSelectedProfile } = this.props;
    setSelectedProfile(profile);
    navigate("products");
  }

  render() {
    const { classes, t, profiles } = this.props;
    return (
      <React.Fragment>
        <div className={classes.headerSection}>
          <i
            className={`material-icons ${classes.headerIcon}`}
            onClick={() => navigate("/")}
          >
            keyboard_arrow_left
          </i>
          <h4 className={classes.headerBreadCrumb}>
            {t("screens.profileSelection.breadCrumb", { brand: "Toyota" })}
          </h4>
        </div>
        <div className={classes.body}>
          <div className={classes.titleSection}>
            <h1 className={classes.title}>
              {t("screens.profileSelection.title")}
            </h1>
          </div>

          <div className={classes.actionsSection}>
            {profiles.map(profile => (
              <Button
                key={profile.nickname}
                className={classes.actions}
                variant="contained"
                size="large"
                color="primary"
                onClick={() => this.handleClick(profile)}
              >
                {profile.nickname}
              </Button>
            ))}
            <Link href="#" underline="none" className={classes.actions_link}>
              {t("screens.profileSelection.action")}
            </Link>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ProfileSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  profiles: PropTypes.array.isRequired,
  profilesHasError: PropTypes.string.isRequired,
  setSelectedProfile: PropTypes.func.isRequired
};

ProfileSelection.defaultProps = {
  profiles: [],
  profilesHasError: ""
};

const mapStateToProps = ({ up }) => ({
  profiles: up.profiles,
  profilesHasError: up.error
});

const mapDispatchToProps = dispatch => ({
  setSelectedProfile: payload =>
    dispatch({
      type: SUBSCRIPTION_ACTION_TYPES.USER_PROFILE.IDENTIFY_PROFILE,
      payload
    })
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(ProfileSelection))
);
